import {
    CommonRoutes,
    FilterType,
} from 'app/enums/common.enums'
import {
    EngagementTableType,
} from 'app/Apps/RelationshipsManagement/Engagement/engagement.types'
import {
    AttitudeToSkyCell,
} from 'app/enums/label.enums'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    SkyNetDomainConfigParams,
} from 'app/PoC/DataGridDemoPages/SkyNetDomainV2/SkyNetDomain.types'
import {
    SkyNetTableField,
} from 'app/shared-components/SkyNetTable'
import {
    RequestConfig,
} from 'app/types/request.types'
import EngagementRequests from 'app/requests/Engagement.requests'

import {
    ColumnConfigMappingType,
} from '../components/SkyNetDataGrid'
import {
    SkyNetDataGridFilterType,
} from '../components/SkyNetDataGrid/SkyNetDataGrid.types'
import EngagementDemoOverview from './EngagementDemoOverview'
import EngagementDemoEditForm from './EngagementDemoEditForm'
import EngagementsDemoCreate from './EngagementsDemoCreate'

const columns: SkyNetTableField<keyof EngagementTableType>[] = [
    {
        name: 'contactName',
        labelKey: 'Engagement.contactName',
        reduced: true,
    },
    {
        name: 'contactCompanyName',
        labelKey: 'Engagement.contactCompanyName',
        filterType: FilterType.Array,
        reduced: true,
    },
    {
        name: 'contactCountryName',
        labelKey: 'Engagement.contactCountryName',
        filterType: FilterType.Array,
    },
    {
        name: 'attitudeToSkyCell',
        labelKey: 'Engagement.attitudeToSkyCell',
        filterType: FilterType.Array,
        componentName: 'AttitudeToSkyCellTable',
        allowedValuesEnum: AttitudeToSkyCell,
    },
]

export const filtersUnrelatedToColumns: ColumnConfigMappingType[] = [{
    name: 'archived',
    minWidth: 50,
    sorting: false,
    filterType: SkyNetDataGridFilterType.Toggle,
    headerName: 'Show Archived Only',
    hiddenFromColumns: true,
}]

const formViews = [
    {
        label: 'Overview',
        url: CommonRoutes.Overview,
        Component: EngagementDemoOverview,
        skyNetQueryLoaderConfig: {
            requestConfigFunction: EngagementRequests.get,
            requestKey: RequestKeys.getEngagement,
        },
    },
    {
        label: 'Data Update',
        url: CommonRoutes.Update,
        Component: EngagementDemoEditForm,
        skyNetQueryLoaderConfig: {
            requestConfigFunction: EngagementRequests.get,
            requestKey: RequestKeys.getEngagement,
        },
    },
]

const request: RequestConfig = {
    url: 'engagement/filter-request/all',
    method: 'POST',
}

const requestProspect: RequestConfig = {
    url: 'engagement/filter-request/prospect',
    method: 'POST',
}

const engagementDomainConfig: SkyNetDomainConfigParams<keyof EngagementTableType> = {
    defaultTab: 1,
    formViews,
    columns,
    config: [
        {
            url: CommonRoutes.All,
            name: 'Prospect Contacts',
            requestKey: RequestKeys.getEngagement,
            request: requestProspect,
        },
        {
            url: 'contacts',
            name: 'Contacts',
            requestKey: RequestKeys.getEngagement,
            request: {
                ...request,
                data: {
                    includeFilters: {
                        contactIsProspect: [false],
                    },
                },
            },
        },
    ],
    actionComponents: {
        Create: {
            component: EngagementsDemoCreate,
            accessOnly: ['relationships_sales'],
        },
    },
}

export default engagementDomainConfig
